import React, { Fragment } from "react";
import { Heading, Loading } from "@myxplor/ui";
import { hasAvailableAction } from "../../ui/gov-actions";
import MainRecord from "./main-record";
import EnrolmentSchedules from "./enrolment-schedules";
import AdditionalConditions from "./additional-conditions";
import Declaration from "./declaration";
import ApprovalSection from "./ApprovalSection";

const enrolmentSchedule = ({ approval_record }) =>
  approval_record.enrolment_schedule;

const isCasualEnrolment = ({ approval_record }) =>
  approval_record.enrolment_schedule.casual &&
  approval_record.enrolment_schedule.casual.length > 0;

const ParentApprovalView = ({
  data,
  loading,
  care_id,
  parent_id,
  refresh_parent_agreement,
}) => {
  if (loading) return <Loading>Loading enrolment details</Loading>;
  if (data === undefined || Object.keys(data).length === 0)
    return (
      <Fragment>
        <Heading small>
          There are no current agreements for you to review
        </Heading>
        <p>If you think this is an error, please contact your service.</p>
      </Fragment>
    );

  const { child, service, parent, agreement_conditions } = data.approval_record;

  return (
    <Fragment>
      <MainRecord record={data.approval_record} />
      {isCasualEnrolment(data) ? null : (
        <EnrolmentSchedules
          child={child}
          service={service}
          {...enrolmentSchedule(data)}
        />
      )}
      <AdditionalConditions agreement_conditions={agreement_conditions} />
      <Declaration />

      <ApprovalSection
        data={data}
        care_id={care_id}
        parent_id={parent_id}
        parent={parent}
        refresh_parent_agreement={refresh_parent_agreement}
        can_sign={hasAvailableAction(data, "can_sign")}
      />
    </Fragment>
  );
};

export default ParentApprovalView;



// WEBPACK FOOTER //
// ./src/parent-agreement/views/index.js